export default __webpack_public_path__ + "746a2438e280a8870f6dae17ca5132e2.ttf";